function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { Link } from 'react-router-dom';
import { getHtmlExcerpt } from '@finect/front-utils/getHtmlExcerpt';
import { Strong } from '@finect/tabular-core/Strong';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { Tabs, TabsPane } from '../../../../Tabs';
import { Image } from '../../../../Image';
import { ManagerContent } from './ManagerContent';
import { HeaderBlock, ManagerBlock, FooterBlock, DescriptionBlock, LastContentBlock, OrganizationLogoBlock } from './partials';
export var Manufacturers = function Manufacturers(_ref) {
  var managers = _ref.managers,
    onTabChange = _ref.onTabChange,
    _ref$managersContents = _ref.managersContents,
    managersContents = _ref$managersContents === void 0 ? [] : _ref$managersContents;
  var handleTabChange = function handleTabChange(event) {
    var manufacturer = managers.find(function (_ref2) {
      var tagline = _ref2.tagline;
      return tagline === event.title;
    });
    manufacturer && onTabChange(manufacturer);
  };
  return React.createElement("div", null, React.createElement(Tabs, {
    wrap: "nowrap",
    variant: "chips",
    size: "small",
    left: true,
    onChange: handleTabChange
  }, managers.map(function (manager) {
    var contentsContainer = managersContents.filter(function (item) {
      return item.manager === manager.alias;
    }).map(function (_ref3) {
      var items = _ref3.items;
      return items;
    });
    var _contentsContainer = _slicedToArray(contentsContainer, 1),
      _contentsContainer$ = _contentsContainer[0],
      contents = _contentsContainer$ === void 0 ? [] : _contentsContainer$;
    var id = manager.id,
      alias = manager.alias,
      icon = manager.icon,
      logo = manager.logo,
      displayName = manager.displayName,
      tagline = manager.tagline,
      description = manager.description;
    var displayDescription = getHtmlExcerpt(description, 220);
    var linkProps = manager.features.blog ? {
      as: Link,
      to: "/grupos/".concat(alias),
      title: "Ver perfil de ".concat(displayName, " en Finect"),
      'data-fi-event': 'manufacturerLogo'
    } : {
      as: 'span'
    };
    return React.createElement(TabsPane, {
      icon: icon,
      title: tagline,
      key: id
    }, React.createElement("div", null, React.createElement(HeaderBlock, null, React.createElement(OrganizationLogoBlock, linkProps, React.createElement(Image, {
      height: 144,
      format: "png",
      src: logo,
      alt: displayName
    }))), React.createElement(ManagerBlock, null, React.createElement(DescriptionBlock, null, React.createElement(Paragraph, null, displayDescription)), contents.length ? React.createElement(LastContentBlock, null, contents.map(function (content, index) {
      return React.createElement(ManagerContent, {
        key: index,
        content: content
      });
    })) : null), React.createElement(FooterBlock, null, React.createElement(AppLink, {
      as: Link,
      to: "/grupos/".concat(alias),
      title: "Ver perfil de ".concat(displayName, " en Finect")
    }, React.createElement(Strong, null, "Ver m\xE1s de ", displayName), React.createElement(ChevronRight, {
      size: "18px",
      strokeWidth: "3"
    })))));
  })));
};